class ButtonVariants {
  primary: boolean = true;
  secondary: boolean = true;
  textOnly: boolean = true;
  iconOnly: boolean = true;
  destructive: boolean = true;
  unstyled: boolean = true;
  disabled: boolean = true;
}

interface TButtonVariants extends ButtonVariants {}

const buttonVariants = [...Object.keys(new ButtonVariants())] as (keyof TButtonVariants)[];

export { buttonVariants };
export type { TButtonVariants };
